import { Helmet } from "react-helmet-async";

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: "Welcome to Stay Chill",
  description: "Productos diferentes para personas diferentes",
  keywords: "parafernalia, 420, remeras",
};

export default Meta;
